import { Stack, Theme, useMediaQuery } from "@mui/material";

import { Loading } from "src/reusable/LoadingSpinner";

const AtomAssistPageLoad = () => {
  const isXlScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("xl"),
  );
  const isLgScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("lg"),
  );
  const isMdScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("md"),
  );
  const isSmScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("sm"),
  );

  let size;
  switch (true) {
    case isXlScreen:
      size = "150px";
      break;
    case isLgScreen:
      size = "135px";
      break;
    case isMdScreen:
      size = "120px";
      break;
    case isSmScreen:
      size = "100px";
      break;
    default:
      size = "100px";
  }

  return (
    <Stack
      sx={{ height: "calc(100vh - 97px)", overflow: "hidden" }}
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        gap={1}
      >
        <Loading width={size} />
      </Stack>
    </Stack>
  );
};

export default AtomAssistPageLoad;
